import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {environment} from '../environments/environment';
import {LoginComponent} from './user/login/login.component';
import {AppRoutingModule} from './app-routing.module';
import {HomeComponent} from './home/home.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FieldComponent} from './field/field.component';
import {TreeComponent} from './field/line/tree/tree.component';
import {LineComponent} from './field/line/line.component';
import {MaterialElevationDirective} from './field/material-elevation.directive';
import {AddFieldComponent} from './field/add-field/add-field.component';
import {FormsModule} from '@angular/forms';
import {ActionMenuComponent} from './action-menu/action-menu.component';
import {EditFieldComponent} from './field/edit-field/edit-field.component';
import {AddTreeComponent} from './field/line/tree/add-tree/add-tree.component';
import {TruffleComponent} from './field/line/tree/truffle/truffle.component';
import {AddTruffleComponent} from './field/line/tree/truffle/add-truffle/add-truffle.component';
import {EditTreeComponent} from './field/line/tree/edit-tree/edit-tree.component';
import {EditTruffleComponent} from './field/line/tree/truffle/edit-truffle/edit-truffle.component';
import {UserComponent} from './user/user.component';
import {EditUserComponent} from './user/edit-user/edit-user.component';
import {ForgotPasswordComponent} from './user/forgot-password/forgot-password.component';
import {SignUpComponent} from './user/sign-up/sign-up.component';
import {BonusComponent} from './bonus/bonus.component';
import {EditBonusComponent} from './bonus/edit-bonus/edit-bonus.component';
import {AddBonusComponent} from './bonus/add-bonus/add-bonus.component';
import {TakeTruffleComponent} from './home/take-truffle/take-truffle.component';
import {TruffleFoundComponent} from './home/truffle/truffle-found.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSliderModule} from '@angular/material/slider';
import {MatListModule} from '@angular/material/list';
import {MatCardModule} from '@angular/material/card';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTableModule} from '@angular/material/table';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {PromptComponent} from './prompt/prompt.component';
import {PwaService} from './services/pwa.service';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {FieldViewComponent} from './home/field-view/field-view.component';
import {YearlyYieldListComponent} from './shared/yearly-yield-list/yearly-yield-list.component';
import {LandingComponent} from './landing/landing.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {provideFirebaseApp, initializeApp, getApps} from '@angular/fire/app';
import {provideAuth, getAuth} from '@angular/fire/auth';
import {provideFirestore, getFirestore, enableIndexedDbPersistence} from '@angular/fire/firestore';

const initializer = (pwaService: PwaService) => () => pwaService.initPwaPrompt();
const firebaseApp = getApps().length ? getApps()[0] : initializeApp(environment.firebase);

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        FieldComponent,
        LineComponent,
        TreeComponent,
        MaterialElevationDirective,
        AddFieldComponent,
        ActionMenuComponent,
        EditFieldComponent,
        AddTreeComponent,
        TruffleComponent,
        TruffleFoundComponent,
        AddTruffleComponent,
        TakeTruffleComponent,
        EditTreeComponent,
        EditTruffleComponent,
        UserComponent,
        EditUserComponent,
        ForgotPasswordComponent,
        SignUpComponent,
        BonusComponent,
        EditBonusComponent,
        AddBonusComponent,
        PromptComponent,
        FieldViewComponent,
        YearlyYieldListComponent,
        LandingComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        BrowserAnimationsModule,
        MatToolbarModule,
        MatSliderModule,
        MatButtonModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatCardModule,
        FormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatDialogModule,
        MatTableModule,
        MatBottomSheetModule,
        MatTooltipModule,
        MatSelectModule,
        // ServiceWorkerModule.register('ngsw-worker.js', {
        //   enabled: environment.production,
        //   // Register the ServiceWorker as soon as the app is stable
        //   // or after 30 seconds (whichever comes first).
        //   registrationStrategy: 'registerWhenStable:30000'
        // }),
    ],
    providers: [
        provideFirebaseApp(() => firebaseApp),
        provideAuth(() => getAuth(firebaseApp)),
        provideFirestore(() => {
            const firestore = getFirestore(firebaseApp);
            enableIndexedDbPersistence(firestore).catch(() => {
                // Ignore persistence errors (multiple tabs, unsupported browsers).
            });
            return firestore;
        }),
        { provide: APP_INITIALIZER, useFactory: initializer, deps: [PwaService], multi: true },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
